const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCurrency(amount: number | undefined | null): string {
  if (amount === undefined || amount === null || Number.isNaN(amount)) return formatter.format(0);
  return formatter.format(amount);
}
